import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { first } from "rxjs/operators";
import { TypeCredit } from "../../core/model/type-credit";
import { Workflow } from "../../core/model/workflow";
import { WorkflowService } from "../../core/service/workflow.service";
import { TypeCreditService } from "../../core/service/type-credit.service";

@Component({
  selector: "app-add-type-credit",
  templateUrl: "./add-type-credit.component.html",
  styleUrls: ["./add-type-credit.component.scss"],
})
export class AddTypeCreditComponent implements OnInit {
  pressButton: Boolean = false;
  form: FormGroup;

  requestType: TypeCredit = new TypeCredit();
  workflows: Workflow[];

  constructor(
    private _router: Router,
    private _workflowService: WorkflowService,
    private _typeCreditService: TypeCreditService,
    private fb: FormBuilder
  ) {
    this.createForm();
  }

  createForm() {
    this.form = this.fb.group({
      active: [null, Validators.compose([Validators.required])],
      code: [null, Validators.compose([Validators.required])],
      label: [null, Validators.compose([Validators.required])],
      workflow: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {
    this.getWorkflows();
  }

  getWorkflows() {
    this._workflowService.getAllWorkflows().subscribe(
      (data) => {
        this.workflows = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  save(): void {
    this._typeCreditService
      .add(this.requestType)
      .pipe(first())
      .subscribe(
        (data) => {
          this._router.navigateByUrl("/parametrage/type-credit");
        },
        (error) => {
          console.log(error);
        }
      );
  }

  cancel(): void {
    this._router.navigate(["/parametrage/type-credit"]);
  }
}
